import {FreeCell, Group} from "../../../../misc/scroller/Table";
import {getSectionName, groupTitle} from "./BeforeGroup";
import {EventEmitter, formatCents, groupByArr, range, selectMany, sum} from "nate-react-api-helpers";
import {useContext, useState} from "react";
import {FilterContext} from "../../../../misc/scroller/Filter";
import { css } from "@emotion/css";
import {blue, grey} from "@mui/material/colors";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {hasPermission, useUser} from "../../../../misc/Permission";
import {QuotePriceLine, SectionName} from "../../../../api/QuotePricing";
import {useAlternative} from "../alternative/Alternative";
import {useIsQuote} from "../QuoteContainer";
import {useGetAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {useColumnIndex} from "../../../../misc/scroller/GroupRowUtil";
import {materialCostColumnName, PriceRow, profit, profit2} from "./Common";
import {DoorSectionContext} from "../../shopdrawing/pricing/DoorSectionProvider";
import {IndexCounter} from "../../shopdrawing/pricing/IndexCounter";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {SectionTotal} from "../SectionTotal";
import {MiscPrice} from "../../../../api/MiscPricing";
import {PriceLine} from "../../../../api/Pricing";
import {ChangePreviewContext} from "../../shopdrawing/ShopDrawingChangePreview";

export function AfterGroup2(props: {
    name: string;
    rows: PriceRow[];
    all: Group<PriceRow>[];
}) {
    const doorSection = useContext(DoorSectionContext)

    let name = (props.name as any) as SectionName
    if(props.name === "hardware-after") {
        name = "hardware";
    }

    if(name.startsWith("door-prep")) {
        name = "door-prep";
    }

    switch(name as any) {
        case "hardware-riders":
            const rows = selectMany(props.all
                .filter(p => p.key === "hardware-riders"), p => p.rows);

            return <AfterGroupInner2 name={name} rows={rows}/>
        case "hardware": {

            const rows = selectMany(props.all
                .filter(p => p.key.startsWith("hardware/") || p.key === "hardware-riders"), p => p.rows);

            return <AfterGroupInner2 name={name} rows={rows}/>
        }

        case "door-hm":
        case "door-wd":
        case "door-other":
        case "door-riders/wd":
        case "door-riders/hm":
        case "door-prep": {
            let rows = props.rows;
            return <AfterGroupInner2 name={name} rows={rows}/>
        }

        case 'div-10/corner-guard-riders':
        case 'div-10/locker-riders':
        case 'div-10/mailbox-riders':
        case 'div-10/wr-accessory-riders':
        case 'div-10/wr-partition-riders':

        case 'div-10/corner-guard':
        case 'div-10/locker':
        case 'div-10/mailbox':
        case 'div-10/wr-accessory':
        case 'div-10/wr-partition': {
            let rows = props.rows;
            return <AfterGroupInner2 name={name} rows={rows}/>
        }
        case "frame-riders":
        case "frame-anchor":
        case "frame-prep":
        case "frame": {
            let rows = props.rows;
            return <AfterGroupInner2 name={name} rows={rows}/>
        }

        case "glazing-riders":
        case "glazing": {
            let rows = props.rows;
            return <AfterGroupInner2 name={name} rows={rows}/>
        }

        case "door-totals": {
            let rows = selectMany(props.all.filter(r => r.key === "door-" + doorSection.tab || r.key === "door-riders/" + doorSection.tab || r.key === "door-prep/" + doorSection.tab), v => v.rows);
            return <AfterGroupInner2 name={name} rows={rows}/>
        }
        case "frame-totals": {
            let rows = selectMany(props.all.filter(r => r.key === "frame" || r.key === "frame-riders" || r.key === "frame-anchor" || r.key === "frame-prep"), v => v.rows);
            return <AfterGroupInner2 name={name} rows={rows}/>
        }
        case "project":
            return <Project2 />
        default:
            return null;
    }
}

export function AfterGroup(props: {
    name: string;
    rows: QuotePriceLine[];
    all: Group<QuotePriceLine>[];
}) {
    const doorSection = useContext(DoorSectionContext)

    let name = (props.name as any) as SectionName
    if(props.name === "hardware-after") {
        name = "hardware";
    }

    if(name.startsWith("door-prep")) {
        name = "door-prep";
    }

    switch(name as any) {
        case "hardware": {

            const rows = selectMany(props.all
                .filter(p => p.key.startsWith("hardware/")), p => p.rows);

            return <AfterGroupInner name={name} rows={rows}/>
        }

        case "door-hm":
        case "door-wd":
        case "door-other":
        case "door-prep":

        case 'div-10/corner-guard':
        case 'div-10/locker':
        case 'div-10/mailbox':
        case 'div-10/wr-accessory':
        case 'div-10/wr-partition':
        case "frame-anchor":
        case "frame-prep":
        case "frame": {
            let rows = props.rows;
            return <AfterGroupInner name={name} rows={rows}/>
        }

        case "door-totals": {
            let rows = selectMany(props.all.filter(r => r.key === "door-" + doorSection.tab || r.key === "door-prep/" + doorSection.tab), v => v.rows);
            return <AfterGroupInner name={name} rows={rows}/>
        }
        case "frame-totals": {
            let rows = selectMany(props.all.filter(r => r.key === "frame" || r.key === "frame-anchor" || r.key === "frame-prep"), v => v.rows);
            return <AfterGroupInner name={name} rows={rows}/>
        }
        case "project":
            return <Project />
        default:
            return null;
    }
}

const blankArray = [] as any;

export function sumPriceLines(rows: QuotePriceLine[] | PriceLine[]) {

    const result =  sum(rows.map(r => {
        return r.extendedPrice
    }));

    console.log("total", result)

    return result;
}

export function sumPriceLines2(rows: PriceRow[]) {

    const result = sum(rows.map(row => {
        if(row.kind === "quote-price") {
            const r = row.value;
            return r.extendedPrice
        }

        if(row.kind === "quote-price-rider") {
            return row.value.extendedPrice;
        }

        return 0;
    }));

    console.log("total", result)

    return result;
}

export const costEachColumnName = "Cost (ea)"

function Project(props: {}) {
    const startIndex = useColumnIndex(costEachColumnName)
    const tbl = useContext(FilterContext);
    const rows = (EventEmitter.reactValue(tbl.srcData) || blankArray) as (QuotePriceLine[]);

    let profitValue = sum(rows.map(profit));
    const price = sumPriceLines(rows)

    let margin = profitValue === 0 ? 0 : Math.round(profitValue / price * 100);

    const u = useUser();

    const project = useProjectId();
    const alternative = useAlternative();
    const isQuote = useIsQuote();

    const previewCtx = useContext(ChangePreviewContext);
    const previewChangeset = previewCtx.enabled ? previewCtx.sessionId : undefined;

    // @ts-ignore
    const list = useGetAll((input) => isQuote ? api.quoteMiscPricing.list(input) : api.miscPricing.list(input),
        {project, alternative, previewChangeset}, [project, alternative, isQuote, previewChangeset], {useLazy: true});

    const isProposing = false
    const miscSum = sum((list.asList as any).map((l: MiscPrice) => {
        if(!isProposing) return l.extendedPrice;

        if(!l.backup)  {
            return 0;
        }

        return l.extendedPrice - l.backup.extendedPrice;
    }))

    const counter = new IndexCounter();

    return (
        <>
            <FreeCell index={counter.incrBy(2)} colSpan={2}>
                <div className={groupTitle}>Total</div>
            </FreeCell>
            {range(startIndex-2).map(key => <FreeCell key={key.toString()} index={counter.incrBy(1)}></FreeCell>)}
            <FreeCell index={counter.incrBy(1)}>
                {!isProposing && <div style={{textAlign: "right"}}>
                    {formatCents(sum(rows.map(cost)) + miscSum)}
                </div>}
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                {!isProposing && <div style={{textAlign: "right"}}>
                    {Math.round((price / fixZero(sum(rows.map(cost))) - 1) * 100)}%
                </div>}
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}></FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(price + miscSum)}
                </div>
            </FreeCell>
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                {!isProposing && <div style={{textAlign: "right"}}>
                    {formatCents(profitValue)}
                </div>}
            </FreeCell>}
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                {!isProposing && <div style={{textAlign: "right"}}>
                    {formatCents(sum(rows.map(r => (r.revenueDelivered || 0) - (r.costDelivered || 0))))}
                </div>}
            </FreeCell>}
            <FreeCell index={counter.incrBy(1)}>
                {!isProposing && <div style={{textAlign: "right"}}>
                    {margin}%
                </div>}
            </FreeCell>
        </>
    )
}

function Project2(props: {}) {
    const startIndex = useColumnIndex(costEachColumnName)
    const tbl = useContext(FilterContext);
    const rows = (EventEmitter.reactValue(tbl.srcData) || blankArray) as (PriceRow[]);

    groupByArr(rows, r => r.kind === "quote-price" ? r.value.productType : r.kind === "quote-price-rider" ? r.value.sectionKey : r.name).forEach(obj => {
        console.log(obj.key,
            formatCents(sum(obj.values.map(v => v.kind === "quote-price" ? v.value.unitCostCents * v.value.qty :
                v.kind === "quote-price-rider" ? v.value.unitCostCents * v.value.qty : 0))))
    })

    const u = useUser();

    const project = useProjectId();
    const alternative = useAlternative();
    const isQuote = useIsQuote();
    const previewCtx = useContext(ChangePreviewContext);
    const previewChangeset = previewCtx.enabled ? previewCtx.sessionId : undefined;

    // @ts-ignore
    const list = useGetAll((input) => isQuote ? api.quoteMiscPricing.list(input) : api.miscPricing.list(input),
        {project, alternative, previewChangeset}, [project, alternative, isQuote, previewChangeset]);

    const miscPrice = sum((list.asList as MiscPrice[]).map(l => l.extendedPrice))
    const miscCost = sum((list.asList as MiscPrice[]).map(l => l.unitCostCents))
    const miscProfit = miscPrice - miscCost;

    const price = sumPriceLines2(rows) + miscPrice

    let profitValue = sum(rows.map(profit2)) + miscProfit;
    let margin = profitValue === 0 ? 0 : Math.round(profitValue / price * 100);

    const counter = new IndexCounter();

    return (
        <>
            <FreeCell index={counter.incrBy(2)} colSpan={2}>
                <div className={groupTitle}>Total</div>
            </FreeCell>
            {range(startIndex-2).map(key => <FreeCell key={key.toString()} index={counter.incrBy(1)}></FreeCell>)}
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(sum(rows.map(unitCost2)) + miscCost)}
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {Math.round((price / fixZero(sum(rows.map(unitCost2)) + miscCost) - 1) * 100)}%
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}></FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(price)}
                </div>
            </FreeCell>
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(profitValue)}
                </div>
            </FreeCell>}
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(sum(rows.map(row => {
                        if(row.kind === "quote-price") {
                            const r = row.value;
                            return (r.revenueDelivered || 0) - (r.costDelivered || 0)
                        }

                        return 0;
                    })))}
                </div>
            </FreeCell>}
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {margin}%
                </div>
            </FreeCell>
        </>
    )
}

function fixZero(value: number) {
    if(value === 0) return 1;
    return value;
}

const clickableCellClass = css({
    textAlign: "right",
    cursor: "pointer",
    border: "2px solid " + grey["400"],
    margin: -6,
    padding: 6,
    paddingTop: 4,
    paddingBottom: 4,

    "&:hover": {
        borderColor: blue["600"]
    }
})

export const qtyColumnName = "Qty"

function AfterGroupInner(props: {
    name: SectionName;
    rows: QuotePriceLine[];
}) {
    const startIndex = useColumnIndex(qtyColumnName)
    let profitValue = sum(props.rows.map(profit));

    const price = sumPriceLines(props.rows)

    let margin = profitValue === 0 ? 0 : Math.round(profitValue / price * 100);
    const [showSectionTotal, setShowSectionTotal] = useState(false)
    const project = useProjectId();
    const ctx = useContext(EditContext)
    const doorSection = useContext(DoorSectionContext)
    const u = useUser();
    const colSpanFirst = props.name === "hardware" ? 3 : 1;
    const noClick = [
        "frame-anchor", "frame", "frame-prep", "door-prep", "door-hm", "door-wd", "door-other"
    ];
    const canClickSectionTotal = noClick.indexOf(props.name) === -1;
    let name: any = props.name;

    // @ts-ignore
    if(props.name === "door-totals") {
        name = "door-" + doorSection.tab;
    }

    const counter = new IndexCounter();

    return (
        <>
            {showSectionTotal && <SectionTotal
                project={project}
                section={name}
                value={price}
                onDone={() => setShowSectionTotal(false)} />}
            <FreeCell index={counter.incrBy(colSpanFirst)} colSpan={colSpanFirst}>
                <div style={{textAlign: colSpanFirst > 1 ? "left" : "right"}} className={groupTitle}>{props.name === "frame-anchor" ? "Anchor" : getSectionName(props.name)} Totals</div>
            </FreeCell>
            {range(startIndex - colSpanFirst).map(id => <FreeCell key={id.toString()} index={counter.incrBy(1)}></FreeCell>)}
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {sum(props.rows.map(qty))}
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(sum(props.rows.map(cost)))}
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {Math.round((price / fixZero(sum(props.rows.map(cost))) - 1) * 100)}%
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}></FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div className={canClickSectionTotal ? clickableCellClass : undefined} style={{textAlign: "right"}} onClick={() => {
                    if(!canClickSectionTotal) return;

                    ctx.onSelect.emit(null)
                    setShowSectionTotal(true)
                }}>
                    {formatCents(price)}
                </div>
            </FreeCell>
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {/* projected profit */formatCents(profitValue)}
                </div>
            </FreeCell>}
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {/* actual profit */formatCents(sum(props.rows.map(r => (r.revenueDelivered || 0) - (r.costDelivered || 0))))}
                </div>
            </FreeCell>}
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {margin}%
                </div>
            </FreeCell>
        </>
    )
}

function AfterGroupInner2(props: {
    name: SectionName;
    rows: PriceRow[];
}) {
    const qtyIndex = useColumnIndex(qtyColumnName);
    const inHouseMaterialCost = useColumnIndex(materialCostColumnName, {
        noWarnForMissing: true
    })
    const hasMaterialCost = inHouseMaterialCost !== -1;
    const startIndex = inHouseMaterialCost !== -1 ? inHouseMaterialCost : qtyIndex;
    let profitValue = sum(props.rows.map(profit2));

    const price = sumPriceLines2(props.rows)

    let margin = profitValue === 0 ? 0 : Math.round(profitValue / price * 100);
    const [showSectionTotal, setShowSectionTotal] = useState(false)
    const project = useProjectId();
    const ctx = useContext(EditContext)
    const doorSection = useContext(DoorSectionContext)
    const u = useUser();

    const colSpanFirst = props.name === "hardware" ? 3 : 1;
    const noClick = [
        "frame-anchor", "frame", "frame-prep", "door-prep", "door-hm", "door-wd", "door-other"
    ];
    const canClickSectionTotal = noClick.indexOf(props.name) === -1;
    let name: any = props.name;

    // @ts-ignore
    if(props.name === "door-totals") {
        name = "door-" + doorSection.tab;
    }

    const counter = new IndexCounter();

    return (
        <>
            {showSectionTotal && <SectionTotal
                project={project}
                section={name}
                value={price}
                onDone={() => setShowSectionTotal(false)} />}
            <FreeCell index={counter.incrBy(colSpanFirst)} colSpan={colSpanFirst}>
                <div style={{textAlign: colSpanFirst > 1 ? "left" : "right"}} className={groupTitle}>{props.name === "frame-anchor" ? "Anchor" : getSectionName(props.name)} Totals</div>
            </FreeCell>
            {range(startIndex - colSpanFirst).map(id => <FreeCell key={id.toString()} index={counter.incrBy(1)}></FreeCell>)}
            {hasMaterialCost && <>
                <FreeCell index={counter.incrBy(1)}>
                    <div style={{textAlign: "right"}}>
                        {formatCents(sum(props.rows.map(r => {
                            if(r.kind === "quote-price") {
                                return r.value.unitMaterialCostCents * r.value.qty;
                            }

                            return 0;
                        })))}
                    </div>
                </FreeCell>
                <FreeCell index={counter.incrBy(1)}>
                    <div style={{textAlign: "right"}}>
                        {formatCents(sum(props.rows.map(r => {
                            if(r.kind === "quote-price") {
                                return r.value.unitInHouseCostCents * r.value.qty;
                            }

                            return 0;
                        })))}
                    </div>
                </FreeCell>
                <FreeCell index={counter.incrBy(1)}></FreeCell>
            </>}
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {sum(props.rows.map(qty2))}
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {formatCents(sum(props.rows.map(cost2)))}
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {Math.round((price / fixZero(sum(props.rows.map(cost2))) - 1) * 100)}%
                </div>
            </FreeCell>
            <FreeCell index={counter.incrBy(1)}></FreeCell>
            <FreeCell index={counter.incrBy(1)}>
                <div className={canClickSectionTotal ? clickableCellClass : undefined} style={{textAlign: "right"}} onClick={() => {
                    if(!canClickSectionTotal) return;

                    ctx.onSelect.emit(null)
                    setShowSectionTotal(true)
                }}>
                    {formatCents(price)}
                </div>
            </FreeCell>
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {/* projected profit */formatCents(profitValue)}
                </div>
            </FreeCell>}
            {hasPermission(u, "CanViewProjectPricingProfit") && <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {/* actual profit */formatCents(sum(props.rows.map(row => {
                        return 0;
                    })))}
                </div>
            </FreeCell>}
            <FreeCell index={counter.incrBy(1)}>
                <div style={{textAlign: "right"}}>
                    {margin}%
                </div>
            </FreeCell>
        </>
    )
}

const cost = (r: QuotePriceLine) => {
    return r.unitCostCents * r.qty
}

const cost2 = (r: PriceRow) => {
    if(r.kind === "quote-price") {
        return r.value.unitCostCents * r.value.qty
    }

    if(r.kind === "quote-price-rider") {
        return r.value.unitCostCents * r.value.qty
    }

    return 0;
}

const qty = (r : QuotePriceLine) => r.qty;

const unitCost2 = (row: PriceRow) => {
    if(row.kind === "quote-price") {
        const r = row.value;
        return r.unitCostCents * r.qty
    }

    if(row.kind === "quote-price-rider")  {
        return row.value.unitCostCents * row.value.qty;
    }

    return 0;
}

const qty2 = (r : PriceRow) => {
    if(r.kind === "quote-price") {
        return r.value.qty;
    }

    return 0;
};